var ENTRY_VIEW_MIN_WIDTH_FOR_REGULAR_BUTTON = 175;
export var shouldUseMobileViewForEntryTile = function (dimensions) {
    var width = dimensions.width;
    var isMobile = Boolean(width < ENTRY_VIEW_MIN_WIDTH_FOR_REGULAR_BUTTON);
    return isMobile;
};
// compressed one line version of regex from https://gist.github.com/dperini/729294#file-regex-weburl-js-L68
// the link above explains the details of the included patterns
export var validateUrl = function (url) {
    var reg = new RegExp(/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/, 'i');
    return reg.test(url);
};
